<template>
<div>
  <Top />
  <div class="maindiv pteacher-wrap  bg-gray">
    <Banner />
    <div class="teachers mt160 bgw htmldiv">
      <banner-title />
      <div class="cont fs0 pt25 pb40">
        <TeachersItem v-for="(item,index) in trachers" :key="index" :index="index" :item="item"/>
      </div>
    </div>
    <div class="ht30"></div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from "../top";
import Banner from "../banner";
import Bottom from "../bottom";
import BannerTitle from "./ttitle";
import TeachersItem from "../teachers-item";
export default {
  name: "index",
  data () {
    return {
      'trachers':[],
    }
  },
  created() {
    this.getData();
  },
  components:{
    Top,
    Banner,
    Bottom,
    BannerTitle,
    TeachersItem,
  },
  methods:{
    getData(){
      var getParam = {};
      this.$request.get('teacher/list',getParam,response => {
        if(response.status == 200){
          var trachers_list = response.data.data;
          this.trachers = trachers_list;
        }
      },error => {
        console.log(error);
      })
    },
  }
}
</script>

<style scoped>
  .pteacher-wrap .teachers .cont{padding: 80px 0 0 60px;}
  .pteacher-wrap .teacher:hover{box-shadow: 0 0 15px #ccc;}
  .pteacher-wrap .teacher:hover .zbtn{transform: scale(1.05);}
  .pteacher-wrap .teacher{margin-bottom: 45px;width: 335px;height: 245px;background: #f2f4f3;}
  .pteacher-wrap .teacher .zbtn{background: #147ad8;color: #fff;}
  .pteacher-wrap .teacher:nth-child(3n + 2){margin-left: 75px;margin-right: 75px;}
</style>



// WEBPACK FOOTER //
// src/components/train/teachers/index.vue